export const ACCESS_PAGES = {
    moderators: {
        key: 'moderators',
        name: 'Մոդերատորներ',
        icon: 'supervised_user_circle',
        crud: false,
        isHidden: false,
    },
    blogs: {
        key: 'blog',
        name: 'Բլոգ',
        icon: 'import_contacts',
        crud: true,
        isHidden: true,
    },
    media: {
        key: 'file',
        name: 'Ֆայլեր',
        icon: 'filter',
        crud: true,
        isHidden: false,
    },
    about: {
        key: 'about',
        name: 'Մեր մասին',
        icon: 'calendar_view_day',
        crud: true,
        isHidden: false,
    },
    slider: {
        key: 'slider',
        name: 'Սլայդեր',
        icon: 'amp_stories',
        crud: true,
        isHidden: false,
    },
    advertisement: {
        key: 'advertisement',
        name: 'Գովազդներ',
        icon: 'filter_vintage',
        crud: true,
        isHidden: false,
    },
    subscribe: {
        key: 'subscriber',
        name: 'Բաժանորդներ',
        icon: 'supervisor_account',
        crud: true,
        isHidden: false,
    },
    languages: {
        key: 'language',
        name: 'Լեզուներ',
        icon: 'language',
        crud: true,
        isHidden: false,
    },
    contact: {
        key: 'contact',
        name: 'Կապ',
        icon: 'contact_phone',
        crud: true,
        isHidden: false,
    },
    staticTexts: {
        key: 'static-texts',
        name: 'Թարգմանություններ',
        icon: 'text_format',
        crud: true,
        isHidden: false,
    },
    menu: {
        key: 'menu',
        name: 'Հղումներ',
        icon: 'receipt',
        crud: true,
        isHidden: false,
    },
    customPages: {
        key: 'dynamic-page',
        name: 'Դինամիկ Էջեր',
        icon: 'group_work',
        crud: true,
        isHidden: false,
    },
};
